import constants from './constants'

// constants for geoserver population density overlays
export default {
  key: 'density',
  server: `${constants.GEOSERVER}`,
  format: 'image/png',
  version: '1.3.0',
  layers: [
    {
      name: 'Total',
      workspace: 'population_both_cohorts',
      id: 'population_both_cohorts:landscan_pop_2016'
    },
    {
      name: 'Total 0-4',
      workspace: 'population_both_cohorts',
      id: 'population_both_cohorts:combined_population_age_0-4'
    },
    {
      name: 'Total 5-9',
      workspace: 'population_both_cohorts',
      id: 'population_both_cohorts:combined_population_age_5-9'
    },
    {
      name: 'Total 10-14',
      workspace: 'population_both_cohorts',
      id: 'population_both_cohorts:combined_population_age_10-14'
    },
    {
      name: 'Total 15-19',
      workspace: 'population_both_cohorts',
      id: 'population_both_cohorts:combined_population_age_15-19'
    },
    {
      name: 'Total 20-24',
      workspace: 'population_both_cohorts',
      id: 'population_both_cohorts:combined_population_age_20-24'
    },
    {
      name: 'Total 25-29',
      workspace: 'population_both_cohorts',
      id: 'population_both_cohorts:combined_population_age_25-29'
    },
    {
      name: 'Total 30-34',
      workspace: 'population_both_cohorts',
      id: 'population_both_cohorts:combined_population_age_30-34'
    },
    {
      name: 'Total 35-39',
      workspace: 'population_both_cohorts',
      id: 'population_both_cohorts:combined_population_age_35-39'
    },
    {
      name: 'Total 40-44',
      workspace: 'population_both_cohorts',
      id: 'population_both_cohorts:combined_population_age_40-44'
    },
    {
      name: 'Total 45-49',
      workspace: 'population_both_cohorts',
      id: 'population_both_cohorts:combined_population_age_45-49'
    },
    {
      name: 'Total 50-54',
      workspace: 'population_both_cohorts',
      id: 'population_both_cohorts:combined_population_age_50-54'
    },
    {
      name: 'Total 55-59',
      workspace: 'population_both_cohorts',
      id: 'population_both_cohorts:combined_population_age_55-59'
    },
    {
      name: 'Total 60-64',
      workspace: 'population_both_cohorts',
      id: 'population_both_cohorts:combined_population_age_60-64'
    },
    {
      name: 'Total 65-69',
      workspace: 'population_both_cohorts',
      id: 'population_both_cohorts:combined_population_age_65-69'
    },
    {
      name: 'Total 70-74',
      workspace: 'population_both_cohorts',
      id: 'population_both_cohorts:combined_population_age_70-74'
    },
    {
      name: 'Total 75-79',
      workspace: 'population_both_cohorts',
      id: 'population_both_cohorts:combined_population_age_75-79'
    },
    {
      name: 'Total 80+',
      workspace: 'population_both_cohorts',
      id: 'population_both_cohorts:combined_population_age_80+'
    },
    {
      name: 'Female',
      workspace: 'population_female_cohorts',
      id: 'population_female_cohorts:landscan_pop_2016_fem'
    },
    {
      name: 'Female 0-4',
      workspace: 'population_female_cohorts',
      id: 'population_female_cohorts:combined_population_female_age_0-4'
    },
    {
      name: 'Female 5-9',
      workspace: 'population_female_cohorts',
      id: 'population_female_cohorts:combined_population_female_age_5-9'
    },
    {
      name: 'Female 10-14',
      workspace: 'population_female_cohorts',
      id: 'population_female_cohorts:combined_population_female_age_10-14'
    },
    {
      name: 'Female 15-19',
      workspace: 'population_female_cohorts',
      id: 'population_female_cohorts:combined_population_female_age_15-19'
    },
    {
      name: 'Female 20-24',
      workspace: 'population_female_cohorts',
      id: 'population_female_cohorts:combined_population_female_age_20-24'
    },
    {
      name: 'Female 25-29',
      workspace: 'population_female_cohorts',
      id: 'population_female_cohorts:combined_population_female_age_25-29'
    },
    {
      name: 'Female 30-34',
      workspace: 'population_female_cohorts',
      id: 'population_female_cohorts:combined_population_female_age_30-34'
    },
    {
      name: 'Female 35-39',
      workspace: 'population_female_cohorts',
      id: 'population_female_cohorts:combined_population_female_age_35-39'
    },
    {
      name: 'Female 40-44',
      workspace: 'population_female_cohorts',
      id: 'population_female_cohorts:combined_population_female_age_40-44'
    },
    {
      name: 'Female 45-49',
      workspace: 'population_female_cohorts',
      id: 'population_female_cohorts:combined_population_female_age_45-49'
    },
    {
      name: 'Female 50-54',
      workspace: 'population_female_cohorts',
      id: 'population_female_cohorts:combined_population_female_age_50-54'
    },
    {
      name: 'Female 55-59',
      workspace: 'population_female_cohorts',
      id: 'population_female_cohorts:combined_population_female_age_55-59'
    },
    {
      name: 'Female 60-64',
      workspace: 'population_female_cohorts',
      id: 'population_female_cohorts:combined_population_female_age_60-64'
    },
    {
      name: 'Female 65-69',
      workspace: 'population_female_cohorts',
      id: 'population_female_cohorts:combined_population_female_age_65-69'
    },
    {
      name: 'Female 70-74',
      workspace: 'population_female_cohorts',
      id: 'population_female_cohorts:combined_population_female_age_70-74'
    },
    {
      name: 'Female 75-79',
      workspace: 'population_female_cohorts',
      id: 'population_female_cohorts:combined_population_female_age_75-79'
    },
    {
      name: 'Female 80+',
      workspace: 'population_female_cohorts',
      id: 'population_female_cohorts:combined_population_female_age_80+'
    },
    {
      name: 'Male',
      workspace: 'population_male_cohorts',
      id: 'population_male_cohorts:landscan_pop_2016_mal'
    },
    {
      name: 'Male 0-4',
      workspace: 'population_male_cohorts',
      id: 'population_male_cohorts:combined_population_male_age_0-4'
    },
    {
      name: 'Male 5-9',
      workspace: 'population_male_cohorts',
      id: 'population_male_cohorts:combined_population_male_age_5-9'
    },
    {
      name: 'Male 10-14',
      workspace: 'population_male_cohorts',
      id: 'population_male_cohorts:combined_population_male_age_10-14'
    },
    {
      name: 'Male 15-19',
      workspace: 'population_male_cohorts',
      id: 'population_male_cohorts:combined_population_male_age_15-19'
    },
    {
      name: 'Male 20-24',
      workspace: 'population_male_cohorts',
      id: 'population_male_cohorts:combined_population_male_age_20-24'
    },
    {
      name: 'Male 25-29',
      workspace: 'population_male_cohorts',
      id: 'population_male_cohorts:combined_population_male_age_25-29'
    },
    {
      name: 'Male 30-34',
      workspace: 'population_male_cohorts',
      id: 'population_male_cohorts:combined_population_male_age_30-34'
    },
    {
      name: 'Male 35-39',
      workspace: 'population_male_cohorts',
      id: 'population_male_cohorts:combined_population_male_age_35-39'
    },
    {
      name: 'Male 40-44',
      workspace: 'population_male_cohorts',
      id: 'population_male_cohorts:combined_population_male_age_40-44'
    },
    {
      name: 'Male 45-49',
      workspace: 'population_male_cohorts',
      id: 'population_male_cohorts:combined_population_male_age_45-49'
    },
    {
      name: 'Male 50-54',
      workspace: 'population_male_cohorts',
      id: 'population_male_cohorts:combined_population_male_age_50-54'
    },
    {
      name: 'Male 55-59',
      workspace: 'population_male_cohorts',
      id: 'population_male_cohorts:combined_population_male_age_55-59'
    },
    {
      name: 'Male 60-64',
      workspace: 'population_male_cohorts',
      id: 'population_male_cohorts:combined_population_male_age_60-64'
    },
    {
      name: 'Male 65-69',
      workspace: 'population_male_cohorts',
      id: 'population_male_cohorts:combined_population_male_age_65-69'
    },
    {
      name: 'Male 70-74',
      workspace: 'population_male_cohorts',
      id: 'population_male_cohorts:combined_population_male_age_70-74'
    },
    {
      name: 'Male 75-79',
      workspace: 'population_male_cohorts',
      id: 'population_male_cohorts:combined_population_male_age_75-79'
    },
    {
      name: 'Male 80+',
      workspace: 'population_male_cohorts',
      id: 'population_male_cohorts:combined_population_male_age_80+'
    }
  ]
}
